<template>
  <div class="marquee" v-show="parsedMessages.length > 0">
    <div class="marquee-content" ref="marqueeContent" :style="{ transform: `translateX(${offset}px)` }">
      <p v-for="(formattedMessage, index) in parsedMessages" :key="index" v-html="formattedMessage"></p>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';

export default {
  name: 'MarqueeText',
  data() {
    return {
      contentWidth: 0,
      animationDuration: 10,
      parsedMessages: [],
      offset: 0,
      requestID: null,
    };
  },
  computed: {
    marqueeStyle() {
      return {
        animationDuration: `${this.animationDuration}s`,
      };
    },
    ...mapState(['marquees']),
  },
  watch: {
    marquees: {
      handler(value) {
        this.parsedMessages = value.map((item) => {
          const message = item.message || '';
          return this.parsedBBCode(this.parseCountdown(message));
        });

        this.$nextTick(() => {
          if (this.$refs.marqueeContent) {
            this.contentWidth = this.$refs.marqueeContent.offsetWidth;
            this.animationDuration = this.calculateAnimationDuration(this.contentWidth);
          }
        });
      },
    },
  },
  async mounted() {
    this.updateMarquees(this.$route);
    this.startAnimation();
    document.addEventListener('visibilitychange', () => {
      if (document.visibilityState === 'visible') {
        this.startAnimation();
      }
    });
  },
  methods: {
    ...mapActions(['updateMarquees']),
    parsedBBCode(message) {
      return message
        .replace(/\[b\]/g, '<b>')
        .replace(/\[\/b\]/g, '</b>')
        .replace(/\[i\]/g, '<i>')
        .replace(/\[\/i\]/g, '</i>')
        .replace(/\[u\]/g, '<u>')
        .replace(/\[\/u\]/g, '</u>')
        .replace(/\[url=(.*?)\](.*?)\[\/url\]/g, '<a href="$1" target="_blank" style="color: inherit; text-decoration: underline;">$2</a>')
        .replace(/\[url\](.*?)\[\/url\]/g, '<a href="$1" target="_blank" style="color: inherit; text-decoration: underline;">$1</a>')
        .replace(/\[color=(.*?)\]/g, '<span style="color:$1;" class="font">')
        .replace(/\[\/color\]/g, '</span>');
    },
    parseCountdown(message) {
      return message.replace(/{countdown:(\d+)}/g, (match, timestamp) => {
        return this.formatCountdown(parseInt(timestamp));
      });
    },
    formatCountdown(timestamp) {
      const targetTime = new Date(timestamp);
      const currentTime = new Date();
      const diff = targetTime - currentTime;

      // If countdown is over, show "即將開始"
      if (diff <= 0) {
        return `${this.$t('common.marquee_key004')}`;
      }

      const days = Math.floor(diff / (1000 * 60 * 60 * 24));
      const hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));

      let countdownStr = '';

      if (days > 0) {
        countdownStr += `${days} ${this.$t('common.marquee_key001')} `; // 天
      }

      if (hours > 0 || days > 0) {
        countdownStr += `${hours} ${this.$t('common.marquee_key002')} `; // 小時
      }

      // Always show minutes if countdown still running
      countdownStr += `${minutes} ${this.$t('common.marquee_key003')} `; // 分鐘

      return countdownStr.trim();
    },
    calculateAnimationDuration(width) {
      const viewportWidth = window.innerWidth;
      const baseSpeed = 10;
      const duration = (width / viewportWidth) * baseSpeed;
      return duration > baseSpeed ? duration : baseSpeed;
    },
    startAnimation() {
      cancelAnimationFrame(this.requestID);

      if (this.offset === 0) {
        this.offset = window.innerWidth;
      }

      const animate = () => {
        this.offset -= 1.5;
        if (this.offset <= -this.contentWidth) {
          this.offset = window.innerWidth;
        }
        this.requestID = requestAnimationFrame(animate);
      };
      this.requestID = requestAnimationFrame(animate);
    },
    beforeUnmount() {
      cancelAnimationFrame(this.requestID);
    },
  },
};
</script>

<style scoped>
.marquee {
  overflow: hidden;
  white-space: nowrap;
  width: 100%;
  background: rgb(23, 23, 23, 0.6);
  backdrop-filter: blur(5px);
  padding: 5px 0;
}

.marquee-content {
  display: inline-block;
  will-change: transform;
}
.marquee-content p {
  display: inline;
  padding: 0 20px;
}
span.font {
  font-size: 10px;
}
.marquee-content span b {
  font-weight: bold !important;
}
.marquee-content span i {
  font-style: italic !important;
}

@media (max-width: 1200px) {
}

@media (max-width: 991px) {
}

@media (max-width: 576px) {
}

@media (max-width: 414px) {
  .marquee-content {
    span {
      font-size: 10px;
    }
    p,
    span,
    i,
    u {
      font-size: 10px;
    }
    span.font {
      font-size: 10px;
    }
  }
}
</style>
